export enum UsuarioBackofficeStatus {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO'
}
